import QuestionExpertPreview from './QuestionExpertPreview'

export default [{
  path: '/expert/:token',
  name: 'QuestionExpertPreview',
  component: QuestionExpertPreview,
  meta: {showNavigation: true, bodyClass: 'light-skin blank'}
}]



// WEBPACK FOOTER //
// ./src/pages/expert/router.js